// @section 1 v5 Sidebar — Workspace + Telemetry groups, ⚡ Capture / Quick action.
// Nav entries are derived from routes/manifest.tsx — to add or reorder a
// sidebar entry, edit ROUTES, not this file.

import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { buildSidebarItems } from '../routes/manifest';

const NAV = buildSidebarItems();

type Props = {
  onCapture: () => void;
  onQuickAction: () => void;
  onSignOut: () => void;
  onNavigate?: () => void;
  envTag?: ReactNode;
};

export function Sidebar({ onCapture, onQuickAction, onSignOut, onNavigate, envTag }: Props) {
  return (
    <aside className="v5-side">
      {NAV.map((item, i) =>
        item.kind === 'label' ? (
          <div
            key={`lbl-${i}`}
            className="nav-label"
            style={item.topGap ? { marginTop: 10 } : undefined}
          >
            {item.label}
          </div>
        ) : (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={() => onNavigate?.()}
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
          >
            <span className="ico">{item.icon}</span>
            <span className="label">{item.label}</span>
            {item.badge != null && <span className="badge">{item.badge}</span>}
            {item.badge == null && item.shortcut && <kbd>{item.shortcut}</kbd>}
          </NavLink>
        )
      )}

      <div className="side-foot">
        <button className="action-btn primary" onClick={onCapture}>
          <span>⚡ Capture</span><kbd>⌘⇧Space</kbd>
        </button>
        <button className="action-btn" onClick={onQuickAction}>
          <span>Quick action</span><kbd>⌘K</kbd>
        </button>
        <button className="action-btn" onClick={onSignOut}>
          <span>Sign out</span>
        </button>
        {envTag && <div className="env-tag">{envTag}</div>}
      </div>
    </aside>
  );
}
